import { Box, Paper, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { ApiContext } from './ApiProvider';

const PreCheckDisabled = () => {
    const { tourOperator } = useContext(ApiContext);

    return (
        <Paper elevation={0} sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
                Pre-check-in Not Available
            </Typography>
            <Typography variant="body1" color="text.secondary">
                Pre-check-in is not available for this tour. Please proceed directly to the tour location at the scheduled time.
            </Typography>
            {tourOperator?.name && (
                <Box sx={{ mt: 3 }}>
                    <Typography variant="body2" color="text.secondary">
                        For any questions, please contact {tourOperator.name}.
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};

export default PreCheckDisabled; 